<script setup lang="ts">
import { BButton } from 'bootstrap-vue-next';
import type { IColumnDefinition, RowData } from '../types';

const props = defineProps<{
  modelValue: any;
  row: RowData;
  column: IColumnDefinition;
}>();

const emit = defineEmits(['update:modelValue', 'change']);

const onLock = () => {
  const newValue = !props.modelValue;
  emit('update:modelValue', newValue);
  emit('change', newValue);
};
</script>

<template>
  <div class="text-center">
    <BButton
      size="sm"
      :variant="modelValue ? 'danger' : 'outline-secondary'"
      class="d-inline-flex align-items-center gap-1"
      @click.stop="onLock"
    >
      <iconify-icon :icon="modelValue ? 'mdi:lock' : 'mdi:lock-open-variant'" />
      {{ modelValue ? 'Unlock' : 'Lock' }}
    </BButton>
  </div>
</template>
